import ContainerDetailWrapper from './ContainerDetailWrapper';

export default ContainerDetailWrapper;
